import { get } from "lodash";

export default {
  getGoals(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/goals?limit=1000`)
        .then(response => {
          context.commit("setGoals", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getThreeExercises(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/exercises?frequency=3&${queryString}`)
        .then(response => {
          context.commit("setThreeExercises", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getFiveExercises(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/exercises?frequency=5&${queryString}`)
        .then(response => {
          context.commit("setFiveExercises", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getExercise(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/exercises/${id}`)
        .then(response => {
          context.commit("setExercise", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getRecordedExercises(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/exercises/recorded?${queryString}`)
        .then(response => {
          context.commit("setRecordedExercises", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getRecordedExercise(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/exercises/recorded/${id}`)
        .then(response => {
          context.commit("setExercise", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getHistory(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/workout/history-exercises?${queryString}`)
        .then(response => {
          context.commit("addHistory", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getMeet(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/lives/meet-zoom")
        .then(response => {
          context.commit("setMeet", get(response.data, "results[0]"));
          resolve();
        })
        .catch(reject);
    });
  },

  getResource(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/workout/resources")
        .then(response => {
          context.commit("setResource", get(response.data, "results[0]"));
          resolve();
        })
        .catch(reject);
    });
  },

  saveExercise(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/workout/history-exercises", data)
        .then(resolve)
        .catch(reject);
    });
  }
};
